<template>
  <div class="spinner-page">
    <span class="loader"></span>
  </div>
</template>
